import React, { useState, useEffect } from 'react';
import CourseCard from './courseCard';
import { connect } from 'react-redux';
import { pageTitle } from '../../utils/const';
import YouTube from 'react-youtube';
import Loader from '../../utils/Loader';
import ListAnimation from '../utils/animations/list';

const mapStateToProps = (state) => {
	return {
		courseDetails: state.rootReducer.changeCourse.courseDetails,
	};
};

const opts = {
	height: '390',
	width: '640',
	playerVars: {
		autoplay: 1,
		controls: 1,
		disablekb: 1,
		fs: 1,
		showinfo: 0,
		loop: 1,
		rel: 0,
		modestbranding: 1,
	},
};

const ListFiller = {
	online: {
		title: `You don't have any pending tasks.`,
		demo: `You can access
a FREE demo
course here!`,

		contentTitle: `What are Online Lessons?`,
		content: `Many of STEP's courses have Online 
Lessons, which comprise Webisodes, 
Tests and Adaptive elements. Webisodes 
are lessons with a video, followed by 
questions based on the video. Every 
course has a Baseline Test to 
understand your current level, and the 
Adaptive elements (more webisodes) are 
decided on the basis of this test. Some courses also have mid-line tests to assess your levels in between, and also certification tests at the end to award you certificates from The Hindu Group!

These lessons will be accessible on Web and Android App, and you'll be able to access all webisodes any number of times without any restrictions. `,
	},
	live: {
		title: `You don't have any pending tasks.`,
		demo: `View an actual
recorded LIVE 
Class here!`,
		demoLink: 'https://www.youtube.com/watch?v=F7ud5DSobRU?rel=0',
		contentTitle: `What are LIVE Classes?`,
		content: `With STEP's LIVE Class, you would be 
able to see the trainer LIVE, ask 
questions LIVE, and participate in polls 
and chat LIVE, all from the comfort of 
your home! All you would need to do is 
ensure a stable internet connection, and 
login at the scheduled time on STEP, and 
we'll make sure you learn something new in the next one hour. 

If you miss a LIVE session, or if you just want to revisit a lesson, you can always see the recorded session, any number of times!`,
	},
	coach: {
		title: `Sorry! You haven't bought any courses with Coach Calls.`,
		demo: `Listen to an actual Coach Call here!`,
		contentTitle: `What are Coach Calls?`,
		demoLink:
			'https://storage.googleapis.com/assets.thehindustep.in/files/5c211728fe820ad73b2ad3157b0b1465.mp3',
		content: `Some of our premium courses have a Coach module. An expert English Trainer will be assigned to you as your very own English Coach! You will be able to schedule Coach Calls at your convenience, and during each call, an aspect of English would be covered. The topics covered would be personalised to your background, requirements, and level of expertise. You might be expected to complete an assignment after each call, and the Coach will be giving you relevant feedback on the next call. Most Coach courses feature Coach Calls on phone. We also have a video Coach Call course for kids, Coach Junior.`,
	},
};
const BuyCoachCourse = ({
	title,
	demo,
	contentTitle,
	content,
	demoLink,
	type,
}) => {
	const [showDemo, toggleDemo] = useState(false);

	useEffect(() => {
		if (showDemo && type === 'coach') {
			document.getElementById(`coachSampleAudio`).load();
		}
	}, [showDemo, type]);

	return (
		<span>
			<div className="buyCoachContainer">
				{title ? <p>{title}</p> : ''}
				<div className="buyCoachContent">
					<h5>{contentTitle}</h5>
					<span> {content} </span>
				</div>
			</div>
		</span>
	);
};

const ListCourse = ({ courseDetails, courseType }) => {
	useEffect(() => {
		Loader.hide();
	}, [courseDetails]);
	return (
		<span>
			{!!courseDetails &&
				courseDetails.length > 0 &&
				courseDetails?.filter((x) => x.type === courseType.substring(1)).length >
				0 ? (
				<ListAnimation open={true} className="course-division">
					<h3 className="section-body-title">
						{pageTitle[courseType.substring(1)]}
					</h3>
					{courseDetails
						?.filter((x) => x.type === courseType.substring(1))
						?.map((course) => (
							<CourseCard key={course.course_id} {...course} />
						))}
				</ListAnimation>
			) : (
				<BuyCoachCourse
					{...ListFiller[courseType.substring(1)]}
					type={courseType.substring(1)}
				/>
			)}

		</span>
	);
};

export default connect(mapStateToProps)(ListCourse);
